import React, { useContext } from 'react';
import { useStyletron } from 'baseui';
import { EmptyFilePill, FilePill } from '@gtintel/platform-atoms';
import { ProjectFilesContext } from '../../ProjectApp/context';
export default () => {
  const {
    reportTemplate,
    sampleReport
  } = useContext(ProjectFilesContext);
  const [css] = useStyletron();
  return <div className={css({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
    marginBottom: '24px',
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr'
    }
  })}>
      {reportTemplate() ? <FilePill file={reportTemplate()} linkText="Report Template" /> : <EmptyFilePill linkText="Report Template missing. Contact GTI" />}
      {sampleReport() && <FilePill file={sampleReport()} linkText="Example" />}
    </div>;
};